import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { mounter } from "oj-dom-utils";
import { EventAggregator } from "oj-eventaggregator";

interface IBasketAmount {
    amount: number
}

// Listener for basket amount
window["ea_BasketAmount"] ??= new EventAggregator<{ basketAmountChanged: number }>();

export class BasketAmount extends MithrilTsxComponent<IBasketAmount> {

    amount: number = 0;

    oninit({ attrs: { amount } }: { attrs: IBasketAmount }) {
        this.amount = amount;
        window["ea_BasketAmount"].on("basketAmountChanged", (e) => {
            this.amount = e;
            m.redraw();
        })
    }

    view({ attrs: { } }: { attrs: IBasketAmount }) {
        return (
            <span class="count">{this.amount}</span>
        );
    }
}

mounter<IBasketAmount>("[data-m-basket-amount]", (r, d) => {
    m.mount(r, {
        oncreate: dom => r.replaceWith(dom.dom),
        view: v => <BasketAmount {...d} />
    })
})